export default __webpack_public_path__ + "static/media/help.c0d347e9.png";